import React from 'react'
import './App.css';
import Header from './Header';
import Sidebar from './Sidebar';
import Login from './Login';
import Chat from './Chat'
import { BrowserRouter as Router, Routes, Route } from "react-router-dom"
import { useStateValue } from './StateProvider';

// import SidebarOption from './SidebarOption';

function App() {


// setup in StateProvider.js, used to pull from the data layer
const [{ user }, dispatch] = useStateValue()

  return (
    <div className="app">
    <Router>
    {!user ? (
     <Login />
    ): (
      <>
      <Header />
      <div className="app__body">
          <Sidebar />
          <Routes>
            <Route path="/room/:roomId" element={<Chat />}/>
          </Routes>
      </div>
      </>
       )}
{/* note the use of a fragment to get the ternary to work. Can't have two siblings next to each other*/}

     


    </Router>
    </div>
  );
}

export default App;
    